<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="currentTab" :stepTitle="stepTitle"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">{{ optionTitle }}信息</span>
            </a-col>
          </a-row>
          <a-button :disabled="proSource!=0" class="mr5" type="primary" @click="editOption(0)">新建{{ optionTitle }}
          </a-button>
          <a-button :disabled="proSource!=0" class="mr5" @click="handleAllOption(1)">批量上架</a-button>
          <a-button :disabled="proSource!=0" @click="handleAllOption(0)">批量下架</a-button>
          <custom-page-table
            style="margin-top: 15px;"
            ref="table"
            rowKey="optionId"
            :queryParams="queryParams"
            :requestPromise="loadPromise"
            :columns="getColumns()"
            childrenColumnName="childrenColumnName"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          >
            <template slot="statusSlot" slot-scope="rowItem">{{ rowItem.record.optionStatus | getProOptionStatusStr }}
            </template>
            <span slot="action" slot-scope="rowItem">
              <a v-if="rowItem.record.optionStatus==1" @click="handleOption(rowItem.record.optionId,0)"
                 :disabled="proSource!=0">下架</a>
              <a v-else :disabled="proSource!=0" @click="handleOption(rowItem.record.optionId,1)">上架</a>
              <a-divider type="vertical"></a-divider>
              <span v-if="catalogId==2">
                <a @click="goHotelPricePlan(rowItem.record.optionId,rowItem.record.optionName)">价格计划</a>
                <a-divider type="vertical"></a-divider>
              </span>
              <span v-if="catalogId==1||catalogId==4||catalogId==73||catalogId==74">
                <a @click="goSetPrice(rowItem.record)">价格库存</a>
                <a-divider type="vertical"></a-divider>
              </span>
              <a @click="editOption(rowItem.record.optionId)">编辑</a>
              <a-divider type="vertical"></a-divider>
              <a-popconfirm title="是否要复制当前行" @confirm="onCopyType(rowItem.record.optionId)">
                <a :disabled="proSource!=0">复制</a>
              </a-popconfirm>
              <a-divider type="vertical"></a-divider>
              <a-popconfirm title="是否要删除当前行" @confirm="onDeleteType(rowItem.record.optionId)">
                <a :disabled="proSource!=0">删除</a>
              </a-popconfirm>
              <span v-if="openWelfare && proSource == 0">
                <a-divider type="vertical"/>
                <AppointDistribution :dataObj="rowItem.record"/>
              </span>
            </span>
          </custom-page-table>
        </a-card>
        <!-- 产品发布按钮 -->
        <PublishPro></PublishPro>
      </div>
      <a-modal title="新增套餐" :visible="popupVisible" width="550px" :footer="null" @cancel="handleCancel">
        <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                      :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-model-item label="套餐名称" prop="optionName">
            <a-input v-model="ruleForm.optionName" placeholder="请输入套餐名称" :maxLength="10"/>
          </a-form-model-item>
          <a-form-model-item label="关联行程" prop="teamRouteId">
            <a-select v-model="ruleForm.teamRouteId" allowClear placeholder="请选择">
              <a-select-option v-for="item in teamRouteList" :key="item.routeId" :value="item.routeId">
                {{ item.routeName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
            <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<script>
import ProductHeader from './ProductHeader'
import PublishHelper from './PublishHelper'
import PublishPro from './PublishPro'
import welfareMallMixins from '@/utils/mixins/welfareMallMixins'

export default {
  name: 'OptionList',
  mixins: [welfareMallMixins],
  components: {
    ProductHeader,
    PublishHelper,
    PublishPro
  },
  data() {
    return {
      popupVisible: false,
      submitLoading: false,
      ruleForm: {
        optionId: 0,
        optionName: '',
        proId: this.$route.query.proId,
        teamRouteId: undefined
      },
      rules: {
        optionName: [
          { required: true, message: '请输入套餐名称', trigger: 'blur' }
        ],
        teamRouteId: [
          { required: true, message: '请选择关联行程', trigger: 'change' }
        ]
      },
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      selectedRowKeys: [],
      queryParams: {
        proId: this.$route.query.proId
      },
      loadPromise: params => this.getListPromise(params),
      selectedStr: '',
      optionTitle: '',
      stepTitle: '',
      submitFormData: '',
      teamRouteList: [],
      currentTab: 1
    }
  },
  mounted() {
    this.currentTab = (this.catalogId == 73 || this.catalogId == 74) ? 3 : 1
    this.getRouteList()
    this.getWelfareInfo() // 获取福利商城信息
  },
  methods: {
    handleCancel() {
      this.popupVisible = false
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.getLogUtils().logWithTag('selectedRowKeys', this.selectedRowKeys)
      this.selectedStr = this.selectedRowKeys.join(',')
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getProService().post('api/v2/productManage/findOptionList', params)
    },
    getColumns() {
      let list = []
      if (this.catalogId == 1) {
        list = [{ title: '票型编号', dataIndex: 'optionId' },
          { title: '票型名称', dataIndex: 'optionName' }]
        this.optionTitle = '票型'
        document.title = '门票-票型列表'
        this.stepTitle = '票型及价格'
      } else if (this.catalogId == 2) {
        list = [{ title: '房型编号', dataIndex: 'optionId' },
          { title: '房型名称', dataIndex: 'optionName' }]
        this.optionTitle = '房型'
        document.title = '酒店-房型列表'
        this.stepTitle = '房型/价格计划'
      } else {
        list = [{ title: '套餐编号', dataIndex: 'optionId' },
          { title: '套餐名称', dataIndex: 'optionName' }]
        document.title = '商品-套餐列表'
        this.optionTitle = '套餐'
        this.stepTitle = '套餐/价格/库存'
      }
      let arrList = [
        {
          title: '建议销售价',
          dataIndex: 'minAdultAdvicePriceStr'
        }, {
          title: '同行价',
          dataIndex: 'minAdultPeerPriceStr'
        }, {
          title: '状态',
          dataIndex: 'optionStatus',
          scopedSlots: { customRender: 'statusSlot' },
          fixed: 'right'
        }, {
          title: '操作',
          dataIndex: 'action',
          width: '350px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
      return [...list, ...arrList]
    },
    handleAllOption(status) {
      if (this.selectedRowKeys.length > 0) {
        let that = this
        let strText = status == 1 ? '批量上架' : '批量下架'
        this.$confirm({
          title: '此操作将' + strText + ', 是否继续?',
          onOk() {
            that.handleOption(that.selectedStr, status)
          },
          onCancel() {
            that.$message.warning('已取消')
          }
        })
      } else {
        this.$message.warning('请选择需要操作的数据')
      }
    },
    handleOption(idStr, status) {
      let text = status == 1 ? '上架' : '下架'
      this.getHttpServices().getProService().post('product/option/changeOptionStatus', {
        optionIds: idStr,
        type: status
      }).then(res => {
        this.getLogUtils().logWithTag('handleOption', res)
        this.$message.success(text + '成功')
        this.$refs.table.refresh(true)
        this.selectedRowKeys = []
        this.selectedStr = ''
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onDeleteType(optionId) {
      this.getHttpServices().getProService().post('product/option/delOption?optionId=' + optionId).then(res => {
        this.getLogUtils().logWithTag('onDeleteType', res)
        this.$message.success('删除成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onCopyType(optionId) {
      this.getHttpServices().getProService().post('product/option/optionCopy?optionId=' + optionId).then(res => {
        this.getLogUtils().logWithTag('onCopyType', res)
        this.$message.success('复制成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    editOption(optionId) {
      let name = ''
      if (this.catalogId == 1) {
        name = 'TicketsOptionInfo'
      } else if (this.catalogId == 2) {
        name = 'HotelOptionInfo'
      } else if (this.catalogId == 3) {
        name = 'VisaProPrice'
      } else if (this.catalogId == 4) {
        name = 'ScenicOptionInfo'
      } else {
        this.popupVisible = true
        if (optionId != 0) {
          this.editTourQuery(optionId)
        } else {
          setTimeout(() => {
            // this.$refs.ruleForm.resetFields();
            this.ruleForm = {
              optionId: 0,
              optionName: '',
              proId: this.$route.query.proId,
              teamRouteId: undefined
            }
          }, 500)
          this.getLogUtils().logWithTag('ruleForm', this.ruleForm)
        }
        return
      }
      this.$router.push({
        name,
        query: {
          proId: this.proId,
          optionId: optionId,
          catalogId: this.catalogId,
          proSource: this.proSource
        }
      })
    },
    // 价格计划
    goHotelPricePlan(optionId, optionName) {
      this.$router.push({
        name: 'HotelPricePlan',
        query: {
          proId: this.proId,
          optionId: optionId,
          catalogId: this.catalogId,
          proSource: this.proSource,
          optionName: optionName
        }
      })
    },
    goSetPrice(data) {
      let name = ''
      if (this.proSource == 0) {
        name = 'ProOwnPrice'
      } else {
        name = 'ProNoOwnPrice'
      }
      this.$router.push({
        name,
        query: {
          proId: this.proId,
          optionId: data.optionId,
          catalogId: this.catalogId,
          proSource: this.proSource,
          optionName: data.optionName
        }
      })
    },
    // 获取套餐信息
    editTourQuery(optionId) {
      this.getHttpServices().getProService().post('product/team/option/query/' + optionId).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.ruleForm = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.getHttpServices().getProService().post('product/team/option/add', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.ruleForm.optionId = res
        this.$message.success('套餐保存成功')
        this.popupVisible = false
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //获取行程ID
    getRouteList() {
      this.getHttpServices().getProService().post('product/team/routeList/query/' + this.proId).then(res => {
        this.getLogUtils().logWithTag('getRouteList', res)
        this.teamRouteList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      flex-grow: 1;
      width: 400px;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.mr5 {
  margin-right: 5px;
}
</style>
